<section *ngIf="isShw()">
    <div style="background-image: url('../../../../assets/images/new-images/Inner-Banner.png'); background-repeat: no-repeat;"
        class="page-header-area sec-overlay sec-overlay-black">
        <div class="container pt--0 pb--0">
            <div class="row">
                <div class="col-12">
                    <div class="page-header-content">
                        <h2 class="title">Start-ups</h2>
                        <nav class="breadcrumb-area">
                            <ul class="breadcrumb justify-content-center">
                                <li><a href="index.html">Home</a></li>
                                <li class="breadcrumb-sep"> / </li>
                                <li>Start-ups</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="recent-job-area bg-color-gray">
    <div class="bg-light">
        <div class="container py-4 popularjobs mt-2">
            <div class="row g-4">
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 1024 1024" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">
                                    Business Development</a>
                            </h5>
                            <p class="text-muted mb-0">74 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 16 16" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5 2H9l-.35.15-.65.64-.65-.64L7 2H1.5l-.5.5v10l.5.5h5.29l.86.85h.7l.86-.85h5.29l.5-.5v-10l-.5-.5zm-7 10.32l-.18-.17L7 12H2V3h4.79l.74.74-.03 8.58zM14 12H9l-.35.15-.14.13V3.7l.7-.7H14v9zM6 5H3v1h3V5zm0 4H3v1h3V9zM3 7h3v1H3V7zm10-2h-3v1h3V5zm-3 2h3v1h-3V7zm0 2h3v1h-3V9z" fill-rule="evenodd" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories"
                                    class="text-decoration-none text-dark">Marketing &amp; Communication</a>
                            </h5>
                            <p class="text-muted mb-0">20 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 1024 1024" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">
                                    Project Management</a>
                            </h5>
                            <p class="text-muted mb-0">35 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div
                            class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 24 24" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM10 5H19V14H10V16H14.3654L17.1889 22H19.3993L16.5758 16H20C20.5523 16 21 15.5523 21 15V4C21 3.44772 20.5523 3 20 3H10V5Z"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">
                                    Software Engineering
                                </a>
                            </h5>
                            <p class="text-muted mb-0">60 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 1024 1024" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">
                                    Human Resource HR</a>
                            </h5>
                            <p class="text-muted mb-0">74 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 16 16" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M14.5 2H9l-.35.15-.65.64-.65-.64L7 2H1.5l-.5.5v10l.5.5h5.29l.86.85h.7l.86-.85h5.29l.5-.5v-10l-.5-.5zm-7 10.32l-.18-.17L7 12H2V3h4.79l.74.74-.03 8.58zM14 12H9l-.35.15-.14.13V3.7l.7-.7H14v9zM6 5H3v1h3V5zm0 4H3v1h3V9zM3 7h3v1H3V7zm10-2h-3v1h3V5zm-3 2h3v1h-3V7zm0 2h3v1h-3V9z">
                                    </path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">
                                    It &amp; Networking
                                </a>
                            </h5>
                            <p class="text-muted mb-0">35 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 1024 1024" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">
                                    Sales &amp; Marketing</a>
                            </h5>
                            <p class="text-muted mb-0">35 Jobs</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                    <div class="card text-center h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                            <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                    viewBox="0 0 24 24" height="2em" width="2em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM10 5H19V14H10V16H14.3654L17.1889 22H19.3993L16.5758 16H20C20.5523 16 21 15.5523 21 15V4C21 3.44772 20.5523 3 20 3H10V5Z"></path>
                                </svg>
                            </div>
                            <h5 class="card-title">
                                <a href="/job-categories" class="text-decoration-none text-dark">Data Science</a>
                            </h5>
                            <p class="text-muted mb-0">60 Jobs</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="post pt-1 container pb-2 pt-2" *ngIf="false">
            <div class="row DCB-card">
                <div class="col-xl-4 col-md-6 mb-5" *ngFor="let course of courseList;">
                    <div class="card profile-card-3 h-100">
                        <div class="background-block">
                            <img [src]="course.IMAGE_URL" alt="profile-sample1" class="background" />
                        </div>
                        <div class="card-content p-4">
                            <div class="text-start mb-3">
                                <h2 class="">{{course.COURSE_NAME}}</h2>
                                <h5 class="mt-1">Who Can Apply</h5>
                                <p>{{course?.courseshd_canappy}}</p>
                                <h5 class="mt-1">Terms Of Engagement</h5>
                                <p>{{course?.courseshd_terms}}</p>
                                <h5 class="mt-1">Classified Type</h5>
                                <p>{{course?.courseshd_classifiedtype_id == 1 ? "Full Time" : "Part Time"}}</p>
                            </div>
                            <div class="text-start mt-4">
                                <p class="text-white mb-2">
                                    {{course.COURSE_DESCRIPTION.substr(0,150)}}
                                    <a *ngIf="course.COURSE_DESCRIPTION.length>75" (click)="gotoCourseDetail(course)"
                                        href="javascript:return(0);">View More</a>
                                </p>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <span class="text-white me-2 fw-bold">{{course.COURSESHD_AMOUNT | currency:'INR'}}</span>
                                    </div>
                                    <div>
                                        <span>
                                            <button class="btn btn-sm btn-outline-light" (click)="gotoCourseDetail(course)">
                                                View Course</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</section>